import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { SearchInput } from 'sections/Resources/FreightForwarder/components/SearchPanel/components/SearchInput';
import { useSearchTerm } from 'sections/Resources/FreightForwarder/hooks/useSearchTerm';
import styles from 'sections/Resources/FreightForwarder/components/SearchPanel/SearchPanel.module.scss';

const cn = classNames.bind(styles);

const CustomStyles = {
  Search: {
    container: {
      maxWidth: '450px',
      width: '100%',
    }
  }
};

const SearchPanel = (): ReactElement => {
  const { setSearchValue, isSearchActive, setIsSearchActive } = useSearchTerm();

  return (
    <div className={cn('search-panel')}>
      <SearchInput
        name="country"
        placeholder="Search for countries"
        customStyles={CustomStyles.Search}
        setSearchValue={setSearchValue}
        isSearchActive={isSearchActive}
        setIsSearchActive={setIsSearchActive}
      />
    </div>
  );
};

export { SearchPanel };